import axios from 'axios';
import API from '../config/api';
import { resHandle, getAxiosErrorMessage } from '../helper';


export const generateWeeklyReport = params =>
    axios.get(API.ADMIN_GENERATE_REPORT + params).then(res => {
        let { status, data } = resHandle(res);
        return { status, data };
    }).catch(error => ({
        status: false,
        data: getAxiosErrorMessage(error, 'Unable to generate weekly report'),
    }));

export const updateCredits = () =>
    axios.get(API.ADMIN_UPDATE_POINTS).then(res => {
        let { status, data } = resHandle(res);
        return { status, data };
    }).catch(error => ({
        status: false,
        data: getAxiosErrorMessage(error, 'Unable to update points'),
    }));

export const getActiveUsersReport = params =>
    axios.get(API.ADMIN_ACTIVE_USERS_REPORT + params).then(res => {
        let { status, data } = resHandle(res);
        return { status, data };
    }).catch(error => ({
        status: false,
        data: getAxiosErrorMessage(error, 'Unable to generate active users report'),
    }));

export const getInactiveUsersReport = params =>
    axios.get(API.ADMIN_INACTIVE_USERS_REPORT + params).then(res => {
        let { status, data } = resHandle(res);
        return { status, data };
    }).catch(error => ({
        status: false,
        data: getAxiosErrorMessage(error, 'Unable to generate inactive users report'),
    }));
